import { CommonResponseModel, vehiclecategoryActivateDeactivateDto} from "@project-management-system/shared-models";
import { CommonAxiosService } from "packages/libs/shared-services/src/common-axios-service-prs";


export class VehicleCategoryService extends CommonAxiosService {
    private VehicleController = "/vehicle_category";

    async createVehicleCategory(req: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VehicleController + "/createVehicleCategory", req)
    }

    async getAllVehicleCategory(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VehicleController + "/getAllVehicleCategory")
    }

    async getActiveAllVehicleCategory(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VehicleController + "/getActiveAllVehicleCategory")
    }
    async updateVehicleCatgeory(dto: any): Promise<CommonResponseModel> {
        return await this.axiosPostCall(this.VehicleController + '/updateVehicleCatgeory', dto)
    }

    async activateOrDeactivateVehicleCategory(req?:vehiclecategoryActivateDeactivateDto): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VehicleController + "/activateOrDeactivateVehicleCategory", req)
    }

}